<div class="app-loader" >
        <mat-spinner color="primary"></mat-spinner>
</div>
